/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import './Devices.scss';
import getResponse from '../utilities/FetchHelper';
import configuration from '../config';
import { useCampusFeatureFlags } from '../context/CampusContextProvider';

import WithRouter from '../utilities/WithRouter';
import { setCurrentCampus, setCurrentEVData } from '../actions';
import ProcessingAndError from '../components/ProcessingAndError';
import EVContent from './subsections/EVContent';
import BatteryContent from './subsections/BatteryContent';
import EditEvGroup from '../components/modals/EditEVGroup';
import EVOverride from '../components/modals/EVOverride';
import EditAllocations from '../components/modals/EditAllocations';
import ConfirmModal from '../components/modals/ConfirmModal';
import BatteryIconNav from '../components/icons/BatteryIconNav';
import EvIconNav from '../components/icons/EvIconNav';
import icon_devices from '../assets/icon_devices.svg';
import { MarketingMessageEv } from '../components/MarketingMessage/MarketingMessageEv';
import { MarketingMessageBattery } from '../components/MarketingMessage/MarketingMessageBattery';

const Devices = ({
  currentCampusId,
  currentEVData,
  updateEVData,
  updateBatteryData,
  showMobile,
  processing,
  setProcessing,
  errorMessage,
  setErrorMessage,
  router,
}) => {
  const { hasBattery, hasEv } = useCampusFeatureFlags();
  const [hasEVs, setHasEvs] = useState(false);
  const [powerDecisions, setPowerDecisions] = useState({});
  const [backupResSettings, setBackupResSettings] = useState({});
  const [selectedModal, setSelectedModal] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedGXId, setSelectedGXId] = useState(null);
  const [allEVs, setAllEVs] = useState([]);
  const [groupIdDelete, setGroupIdDelete] = useState(null);
  const [modalMessage, setModalMessage] = useState('');
  const [confirmAction, setConfirmAction] = useState('');
  const errorMessageRef = useRef(null);

  const location = useLocation();
  const deviceMenuActive = location.pathname.split('/')[3]?.toLowerCase();

  const powerDecisionsOrder = ['Microgrid', 'Critical', 'Conserve', 'Standard', 'Performance'];

  let initialPowerDecisions;

  function sortedPowerDecisions() {
    let tempPowerDecisions = {};

    currentEVData?.gridInterconnectEvChargers?.map((item) => {
      item?.evChargerGroups.map((group) => {
        initialPowerDecisions = group.powerDecisionLimits;
      });
    });

    powerDecisionsOrder.forEach((key) => {
      if (initialPowerDecisions?.hasOwnProperty(key)) {
        tempPowerDecisions[key] = initialPowerDecisions[key];
      }
    });

    setPowerDecisions(tempPowerDecisions);
  }

  useEffect(() => {
    if (currentEVData) {
      sortedPowerDecisions();
    }
  }, []);

  //Call device API when campus or nav change
  useEffect(() => {
    if (deviceMenuActive === 'ev') {
      setHasEvs(false);
      updateEVData();
    } else {
    }
  }, [currentCampusId, deviceMenuActive]);

  //When device data updates, reload
  useEffect(() => {
    if (deviceMenuActive === 'ev') {
      if (currentEVData) {
        sortedPowerDecisions();

        // for each currentEVData.gridInterconnectEvChargers, check if evChargerGroups exist
        if (currentEVData?.gridInterconnectEvChargers) {
          //check if group has any EVs
          currentEVData.gridInterconnectEvChargers.forEach((interconnect) => {
            if (interconnect.evChargerGroups && interconnect.evChargerGroups.length > 0) {
              interconnect.evChargerGroups.forEach((group) => {
                if (group.evChargers && group.evChargers.length > 0) {
                  setHasEvs(true);
                }
              });
            }
          });
        } else {
          setHasEvs(false);
        }

        let interval = setInterval(() => {
          updateEVData();
        }, 5000);

        return () => clearInterval(interval);
      }
    }
  }, [currentEVData]);

  const clearModal = () => {
    setSelectedModal(null);
  };

  const handleCancelOverride = () => {
    clearModal();
    setProcessing(true);

    getResponse(
      configuration['backend_host'] +
        '/ahiapi/' +
        selectedGXId +
        '/gridInterconnect/evChargerGroup/override/' +
        groupIdDelete,
      true,
      'DELETE',
      null,
      updateEVData,
      setProcessing,
      errorMessage,
      setErrorMessage,
      errorMessageRef
    );
  };

  const handleDelete = () => {
    clearModal();
    setProcessing(true);

    getResponse(
      configuration['backend_host'] +
        '/ahiapi/' +
        selectedGXId +
        '/gridInterconnect/evChargerGroup/' +
        groupIdDelete,
      true,
      'DELETE',
      null,
      updateEVData,
      setProcessing,
      errorMessage,
      setErrorMessage,
      errorMessageRef
    );
  };

  const openEVModal = (selectModal, groupId, action, gxId) => {
    setSelectedGXId(gxId);

    setConfirmAction(action);
    setSelectedModal(selectModal);

    if (selectModal === 'edit-ev' || selectModal === 'override') {
      updateEVData();

      currentEVData.gridInterconnectEvChargers.map((groups) => {
        if (groups.gridInterconnectEntityKey === gxId) {
          setAllEVs([]);

          groups.evChargerGroups.map((group) => {
            group.powerDecisionLimits = powerDecisions;
            group.evChargers.map((charger) => {
              setAllEVs((prevState) => [...prevState, charger]);
            });

            if (groupId !== '') {
              if (group.evChargerGroupId === groupId) {
                setSelectedGroup(group);
              }
            } else {
              setSelectedGroup({
                evChargerGroupName: 'New Group',
                evChargerGroupId: '',
                evChargers: [],
                powerDecisionLimits: {
                  Microgrid: 0,
                  Critical: 0,
                  Conserve: 0,
                  Standard: 0,
                  Performance: 0,
                },
              });
            }
          });
        }
      });
    }

    if (selectModal === 'confirm') {
      setSelectedGXId(gxId);
      setGroupIdDelete(groupId);

      if (action === 'delete') {
        setModalMessage('Are you sure you want to delete this group?');
      } else {
        setModalMessage('Are you sure you want to cancel the override for this group?');
      }
    }
  };

  const openBatteryModal = (selectModal, gxId) => {
    setSelectedGXId(gxId);
    setSelectedModal(selectModal);
  };

  const renderModal = () => {
    switch (selectedModal) {
      case 'edit-ev':
        return (
          <EditEvGroup
            modalImage={icon_devices}
            clearModal={clearModal}
            currentCampusId={currentCampusId}
            currentEVData={currentEVData}
            selectedGXId={selectedGXId}
            selectedGroup={selectedGroup}
            setProcessing={setProcessing}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            errorMessageRef={errorMessageRef}
            updateEVData={updateEVData}
            showMobile={showMobile}
            allEVs={allEVs}
          />
        );
      case 'override':
        return (
          <EVOverride
            modalMessage={''}
            modalImage={icon_devices}
            clearModal={clearModal}
            currentCampusId={currentCampusId}
            selectedGXId={selectedGXId}
            selectedGroup={selectedGroup}
            setProcessing={setProcessing}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            errorMessageRef={errorMessageRef}
            updateEVData={updateEVData}
            showMobile={showMobile}
          />
        );
      case 'confirm':
        return (
          <ConfirmModal
            modalMessage={modalMessage}
            modalAction={
              confirmAction === 'delete' ? () => handleDelete() : () => handleCancelOverride()
            }
            clearModal={clearModal}
          />
        );
      case 'edit-battery':
        return (
          <EditAllocations
            modalImage={icon_devices}
            clearModal={clearModal}
            backupResSettings={backupResSettings}
            selectedGXId={selectedGXId}
            setProcessing={setProcessing}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            errorMessageRef={errorMessageRef}
            updateBatteryData={updateBatteryData}
            showMobile={showMobile}
          />
        );
      default:
        return false;
    }
  };

  const modal = renderModal();

  const renderDeviceIcon = () => {
    if (deviceMenuActive === 'ev') {
      return (
        <EvIconNav
          backgroundFill="none"
          fillColor="#02222B"
          strokeColor={'#02222B'}
          strokeWidth={2.5}
          width="18px"
        />
      );
    } else if (deviceMenuActive === 'battery') {
      return (
        <BatteryIconNav
          backgroundFill="none"
          fillColor="#02222B"
          strokeColor={'#02222B'}
          strokeWidth={2.5}
          width="18px"
        />
      );
    }
  };

  return (
    <section className={`page--devices ${showMobile ? 'mobile' : 'desktop'}`}>
      <div className={showMobile ? 'header-container mobile' : 'header-container'}>
        <div className="title-menu">
          <div className="header">
            {renderDeviceIcon()}
            <h1>{deviceMenuActive === 'ev' ? 'EV' : 'Battery'}</h1>
          </div>
        </div>
      </div>

      <section className="devices-section">
        {modal}

        <ProcessingAndError
          processing={processing}
          errorMessage={errorMessage}
          errorMessageRef={errorMessageRef}
        />

        {deviceMenuActive === 'ev' ? (
          <>
            {hasEVs ? (
              <EVContent
                openEVModal={openEVModal}
                showMobile={showMobile}
                currentEVData={currentEVData}
                powerDecisions={powerDecisions}
              />
            ) : (
              <>
                <MarketingMessageEv />
              </>
            )}
          </>
        ) : (
          <>
            {hasBattery ? (
              <BatteryContent
                currentCampusId={currentCampusId}
                openBatteryModal={openBatteryModal}
                showMobile={showMobile}
              />
            ) : (
              <>
                <MarketingMessageBattery />
              </>
            )}
          </>
        )}
      </section>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    currentCampusId: state.currentCampusId,
    currentEVData: state.currentEVData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
    setCurrentEVData: (evData) => {
      dispatch(setCurrentEVData(evData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Devices));
